/**
 * ASSIST-01 — the Assist card's GA4 events (brief R22, section 7).
 *
 * Imports only `sendGaEvent` from the guard, like utils/gaCommerceEvents.ts,
 * so every event inherits the consent gate, the route blocklist, the staff
 * exclusion and the GA4-only `send_to`. The native app sends nothing (the guard
 * never boots there).
 *
 * Params are closed: no listing id on these two (R22 allows `listing_id` only
 * on `assist_request_*`), and never a name, phone, email, budget or case id.
 */
import { sendGaEvent } from '../../../utils/gaGuard';
import type { AssistMode } from './config';

/** Listing ids whose card has been counted in this page load. */
const viewedListings = new Set<string>();

/**
 * `assist_cta_view`, once per listing per page load. A property page mounts
 * the card twice (mobile and desktop copies) and, on web, a listing click can
 * mount both render trees; this set is what keeps that at one event.
 */
export function trackAssistCtaView(listingId: string, assistMode: AssistMode): void {
  if (viewedListings.has(listingId)) return;
  viewedListings.add(listingId);
  sendGaEvent('assist_cta_view', { assist_mode: assistMode });
}

let interestSubmitSent = false;

/**
 * `assist_interest_submit`, when a registration creates the waitlist row.
 * Once per page load: both card copies share one registration.
 */
export function trackAssistInterestSubmit(): void {
  if (interestSubmitSent) return;
  interestSubmitSent = true;
  sendGaEvent('assist_interest_submit');
}
